/* DHC v1052.25 — final interaction hardening */
(function(){
  'use strict';
  function qs(s,r){return (r||document).querySelector(s)}
  function qsa(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  function focusables(root){return qsa('a[href],button:not([disabled]),textarea:not([disabled]),input:not([disabled]),select:not([disabled]),[tabindex]:not([tabindex="-1"])',root).filter(function(x){return x.offsetParent!==null})}
  function trap(e,root){if(e.key!=='Tab'||!root)return;var f=focusables(root);if(!f.length)return;var first=f[0],last=f[f.length-1];if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus()}else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus()}}
  function cart(){return qs('[data-cart-drawer]')}
  function jack(){return qs('[data-support-panel]')}
  function launcher(){return qs('[data-support-open]')}
  function cartOpen(){var c=cart();return !!(c&&(c.classList.contains('is-open')||c.getAttribute('aria-hidden')==='false'))}
  function jackOpen(){var j=jack();return !!(j&&(j.classList.contains('is-open')||j.getAttribute('aria-hidden')==='false'))}
  function sync(){
    var c=cart(),j=jack(),l=launcher();
    var co=cartOpen(),jo=jackOpen();
    document.documentElement.classList.toggle('dhc-cart-open',co);document.body.classList.toggle('dhc-cart-open',co);
    if(l)l.setAttribute('aria-expanded',jo?'true':'false');
    if(j)j.setAttribute('aria-hidden',jo?'false':'true');
    if(c)c.setAttribute('aria-hidden',co?'false':'true');
    if(co&&jo){try{if(window.DHCCloseJack)window.DHCCloseJack()}catch(_){}}
  }
  document.addEventListener('keydown',function(e){
    if(cartOpen())trap(e,cart());
  },true);
  document.addEventListener('click',function(){setTimeout(sync,0)},true);
  document.addEventListener('dhc:cart:updated',function(){setTimeout(sync,0)});
  document.addEventListener('shopify:section:load',function(){setTimeout(sync,0)});
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){sync();});else sync();
})();
